import { router } from '@inertiajs/react'
import { ClipboardCheck, ExternalLink } from 'lucide-react'

interface Props {
  show: boolean
}

export default function SurancebayNotice({ show }: Props) {
  if (!show) return null

  const handleComplete = () => {
    router.post('/my/surancebay/complete', {}, { preserveScroll: true })
  }

  return (
    <div className="card border-l-4 border-l-chestnut-forest bg-green-50">
      <div className="flex items-start gap-3">
        <ClipboardCheck className="h-6 w-6 mt-0.5 flex-shrink-0 text-chestnut-forest" />
        <div className="flex-1 min-w-0">
          <h2 className="text-lg font-semibold text-chestnut-charcoal font-heading">
            Complete your SuranceBay producer profile
          </h2>
          <p className="text-sm text-chestnut-charcoal/80 mt-1">
            Once you are contracted with FFR, completing the forms at{' '}
            <a
              href="https://surelc.surancebay.com/sbweb/agency/495"
              target="_blank"
              rel="noopener noreferrer"
              className="text-chestnut-forest font-medium underline break-all"
            >
              https://surelc.surancebay.com/sbweb/agency/495
            </a>
            {' '}will be required to place business in force — if you need any assistance in completing these please see the two links provided below.
          </p>
          <ul className="mt-3 space-y-1.5">
            <li>
              <a
                href="https://surancebay.zendesk.com/entries/47138830-Producer-Profiles"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-sm text-chestnut-forest hover:underline"
              >
                <ExternalLink className="h-4 w-4 flex-shrink-0" />
                Producer Profiles
              </a>
            </li>
            <li>
              <a
                href="https://surancebay.zendesk.com/entries/21966771-Producer-Training-Video-for-SureLC-Web-3-0-Video-"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-sm text-chestnut-forest hover:underline"
              >
                <ExternalLink className="h-4 w-4 flex-shrink-0" />
                Producer Training Video for SureLC Web 3.0
              </a>
            </li>
          </ul>
          <div className="mt-4">
            <button
              type="button"
              onClick={handleComplete}
              className="inline-flex items-center px-4 py-2 rounded-lg bg-chestnut-forest text-white text-sm font-medium hover:bg-chestnut-forest/90"
            >
              Complete this
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
